import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './analytics';

/** Fires GA4/GTM/Pixel page_view on every route change. Mount inside <BrowserRouter>. */
export default function RouteTracker() {
  const loc = useLocation();
  useEffect(() => {
    trackPageView(loc.pathname + loc.search);
  }, [loc.pathname, loc.search]);
  return null;
}
